import { Show } from '@legendapp/state/react';
import { type ReactNode } from 'react';
import { type Observable, type Selector } from '@legendapp/state';
import { AnimatePresence, type AnimatePresenceProps } from 'framer-motion';

export type AnimatePresenceShowProps<T> = AnimatePresenceProps & {
    children: ReactNode;
    if: Selector<T>;
    ifReady?: never;
    else?: ReactNode | (() => ReactNode);
    $value?: Observable<T>;
};

export function AnimatePresenceShow<T>({
    children,
    initial = false,
    custom,
    onExitComplete,
    mode = 'popLayout',
    root,
    presenceAffectsLayout,
    propagate,
    anchorX,
    ...rest
}: AnimatePresenceShowProps<T>) {
    return (
        <Show<T>
            {...rest}
            wrap={({ children }: { children: ReactNode }) => (
                <AnimatePresence
                    initial={initial}
                    custom={custom}
                    onExitComplete={onExitComplete}
                    mode={mode}
                    root={root}
                    presenceAffectsLayout={presenceAffectsLayout}
                    propagate={propagate}
                    anchorX={anchorX}
                >
                    {children}
                </AnimatePresence>
            )}
        >
            {() => children}
        </Show>
    );
}
